import { IAddress } from '../interfaces/models';
import { ID } from '@datorama/akita';

export class Address implements IAddress {
  id: ID;
  // eslint-disable-next-line id-blacklist
  number: string;
  unit: string;
  streetAddress: string;
  city: string;
  clli: string;
  internet: boolean;
  tv: boolean;
  date: Date;

  constructor(
    address: IAddress = {
      id: '',
      // eslint-disable-next-line id-blacklist
      number: '',
      unit: '',
      streetAddress: '',
      city: '',
      clli: '',
      internet: false,
      tv: false,
      date: new Date(),
    }
  ) {
    const {
      id,
      // eslint-disable-next-line id-blacklist
      number,
      unit,
      streetAddress,
      city,
      clli,
      internet,
      tv,
      date,
    } = address;

    this.id = id;
    // eslint-disable-next-line id-blacklist
    this.number = number;
    this.unit = unit;
    this.streetAddress = streetAddress;
    this.city = city;
    this.clli = clli;
    this.internet = internet;
    this.tv = tv;
    this.date = date;
  }

  // Since ion datepicker receives a string in iso 8601 and
  // returns a string, I created this property to manage that
  get dateFormatted(): string {
    return this.date.toISOString();
  }

  set dateFormatted(date: string) {
    this.date = new Date(date);
  }

  static createFromDTO(item): Address {
    return new Address({
      id: item.id,
      // eslint-disable-next-line id-blacklist
      number: item.number,
      unit: item.unit,
      streetAddress: item.streetAddress,
      city: item.city,
      clli: item.clli,
      internet: item.internet,
      tv: item.tv,
      date: new Date(item.date),
    });
  }
}
